import { Query } from '@shared/utils';

interface PaginationQuery {
    queryPage: number;
    queryPageSize: number;
}

interface FixOptions {
    initialPage: number;
    initialPageSize: number;
    totalCount: number | null;
    query: Query;
    pageQueryName: string;
    pageSizeQueryName: string;
}

export function fixPaginationQuery(options: FixOptions): PaginationQuery {
    const { initialPage, initialPageSize, totalCount, query, pageQueryName, pageSizeQueryName } = options;

    let queryPage = initialPage;
    let queryPageSize = initialPageSize;

    let targetPage = query[pageQueryName];
    let targetPageSize = query[pageSizeQueryName];

    if (typeof targetPage !== 'number' && typeof targetPageSize !== 'number') {
        // pass
    } else if (typeof targetPage !== 'number' && targetPageSize > 0) {
        queryPageSize = targetPageSize;
    } else if (typeof targetPageSize !== 'number' && targetPage > 0) {
        queryPage = targetPage;
    } else {
        queryPage = targetPage > 0 ? targetPage : queryPage;
        queryPageSize = targetPageSize > 0 ? targetPageSize : queryPageSize;
    }

    if (totalCount !== null) {
        if (validateCountMatch(queryPage, queryPageSize, totalCount)) {
            return { queryPage, queryPageSize };
        } else {
            return {
                queryPage: initialPage,
                queryPageSize: initialPageSize,
            };
        }
    } else {
        return { queryPage, queryPageSize };
    }
}

// validated if true
function validateCountMatch(page: number, pageSize: number, totalCount: number): boolean {
    return pageSize * (page - 1) - totalCount < 0;
}
